var React = require('react');

function Gem (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M100.7 192H0l218.7 255a3 3 0 0 0 5-3.3zm374.6 0l-123 251.7a3 3 0 0 0 5 3.2L576 192zm-327.1 0l137.1 318.2a3 3 0 0 0 5.5 0l137-318.2z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M90.5 0L0 160h101.1L170.3 0zm395 0h-79.8l69.2 160H576zm-267 0l-69.2 160h277.4L357.5 0z","className":"fa-primary","key":2})]);
}

Gem.defaultProps = {"viewBox":"0 0 576 512","className":"icon"};

module.exports = Gem;

Gem.default = Gem;
